// ==============================|| OVERRIDES - PICKER CALENDAR HEADER ||============================== //

export default function PickersCalendarHeader (theme) {
    return {
        MuiPickersCalendarHeader: {
            styleOverrides: {
                // root: {

                // },
                // labelContainer: {

                // }
            }
        }
    }
}
